import axios from 'axios';

const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    if (process.env.REACT_APP_API_URL) {
      if (process.env.REACT_APP_API_URL === '/') {
        return '';
      }
      return process.env.REACT_APP_API_URL;
    }
    const hostname = window.location.hostname;
    return `http://${hostname}:5000`;
  }
  
  const apiUrl = process.env.REACT_APP_API_URL || "";
  if (apiUrl === '/') {
    return '';
  }
  return apiUrl;
};

const baseUrl = getBaseUrl();

const csrfAxios = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Global variable to coordinate token refreshes
let tokenRefreshPromise = null;

/**
 * Helper function to get a cookie value by name.
 */
function getCookieValue(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

/**
 * Get CSRF token exclusively from the cookie.
 */
export const getCsrfToken = () => {
  const cookieToken = getCookieValue('csrf_token');
  if (!cookieToken) {
  }
  return cookieToken;
};

/**
 * Fetch a new CSRF token from the server.
 * Uses a shared promise to coordinate concurrent refreshes.
 * @returns {Promise<string>} The CSRF token.
 */
export const fetchCsrfToken = async () => {
  // If a token refresh is already in progress, wait for it.
  if (tokenRefreshPromise) {
    return tokenRefreshPromise;
  }
  
  // Start a new token refresh promise.
  tokenRefreshPromise = new Promise(async (resolve, reject) => {
    try {
      const response = await csrfAxios.get('/api/get-csrf-token');
      
      if (response.data && response.data.csrf_token) {
        const token = response.data.csrf_token;
        
        // Optional: Wait a bit for the cookie to be set properly
        setTimeout(() => {
          const cookieToken = getCookieValue('csrf_token');
          if (!cookieToken) {
          }
        }, 300);
        
        resolve(token);
      } else {
        reject(new Error('Invalid response format from server'));
      }
    } catch (error) {
      if (error.response) {
      }
      reject(error);
    } finally {
      // Clear the promise variable so a new refresh can be triggered later if needed.
      tokenRefreshPromise = null;
    }
  });
  
  return tokenRefreshPromise;
};

/**
 * Clear the CSRF token by expiring the cookie.
 */
export const clearCsrfToken = () => {
  document.cookie = 'csrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export default {
  fetchCsrfToken,
  getCsrfToken,
  clearCsrfToken
};